import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlSegment, UrlTree} from '@angular/router';
import {UsuarioServices} from '../../CoreModule/services/usuario.services';
import {Observable} from 'rxjs';
import {PERMISOS} from '../../variables';

@Injectable()
export class RvgSecurityServices implements CanActivate{
  constructor(private us: UsuarioServices) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isLogin = this.us.isLogin();
    if (isLogin) {


      return this.comprobarPermisos(route.url);
    } else {
      this.us.irALogin();
      return false;
    }
  }
  comprobarPermisos(url: UrlSegment[]) {

    let entidad = (url.length>1)? url[2].path:"";
    let accion = (url.length > 3) ? url[3].path : '';
    let raiz = url[0].path;

    switch (entidad) {
      case 'categorias':
        return this.us.comprobarPermisos(PERMISOS.ADMINRVG);
      case 'subcategorias':
        return this.us.comprobarPermisos(PERMISOS.ADMINRVG);
      case 'preguntas':
        return this.us.comprobarPermisos(PERMISOS.ADMINRVG);
      case 'plantillas':
        return this.us.comprobarPermisos(PERMISOS.ADMINRVG);
      case 'visitas':
        return this.us.comprobarPermisos(PERMISOS.CREARVISITASRVG);
    }


    switch (raiz) {
      case 'visitas':
        return this.us.comprobarPermisos(PERMISOS.VERRVG);
    }
  }

}
